import React from "react";
import ExcelJS from "exceljs";

const UseExcelDownload = ({ data, column, excelTitle }) => {
    const exportExcelFile = async () => {
        if (!Array.isArray(data)) {
            console.error("Data is not an array:", data);
            return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Sheet1');

        // Define columns with headers
        worksheet.columns = column;

        // Apply alignment and color to header cells
        worksheet.getRow(1).eachCell((cell) => {
            cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFF00' }, // Yellow color
            };
            cell.font = { bold: true, size: 14 };
        });

        const flattenedData = data;

        // Add data rows with custom cell alignment and wrap text
        flattenedData.forEach(item => {
            const row = worksheet.addRow(item);
            row.eachCell((cell) => {
                cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            });
        });
        const currentDate = new Date();
        const formattedDate = `${currentDate.getDate().toString().padStart(2, '0')}-${(currentDate.getMonth() + 1).toString().padStart(2, '0')}-${currentDate.getFullYear()}`;
        // Generate Excel file buffer
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = `${excelTitle} ${formattedDate}.xlsx`;
        anchor.click();
        window.URL.revokeObjectURL(url);
    };

    return (
        <>
            <button className="excel-download-btn" onClick={exportExcelFile}>
                Download as Excel
            </button>
        </>
    );
};

export default UseExcelDownload;
